// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"9c997fc1","787":"91535c92","856":"64cead64"}[chunkId] + ".chunk.js";
};